import { render, staticRenderFns } from "./UserInfo.vue?vue&type=template&id=4adc6563&scoped=true"
import script from "./UserInfo.vue?vue&type=script&lang=js"
export * from "./UserInfo.vue?vue&type=script&lang=js"
import style0 from "../../assets/css/user-info.css?vue&type=style&index=0&id=4adc6563&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4adc6563",
  null
  
)

export default component.exports